/** The digits of an authenticator code as filled, pasted or typed — spaces
 * and dashes some apps put in the middle dropped — capped at six. */
export function totpDigits(value: string): string {
  return value.replace(/\D/g, "").slice(0, 6);
}
